export const educationData = [
    {
        id: 1,
        institution: 'Dronacharya College of Engineering, Gurgaon',
        course: 'Bachelor of Technology - CSE',
        startYear: '2020',
        endYear: '2023',
        score: '71.1%'
    },
    {
        id: 2,
        institution: 'Swaminarayan College of Engineering & Technology, Ahmedabad',
        course: 'Diploma',
        startYear: '2017',
        endYear: '2020',
        score: '77.2%'
    },
    {
        id: 3,
        institution: 'Shree Swaminarayan International School, Ahmedabad',
        course: 'Secondary Education',
        startYear: '2015',
        endYear: '2017',
        score: '70%'
    },
]